module.exports = __webpack_public_path__ + "static/media/galerija_2016 (10).6b3d7108.jpg";